import axios, { AxiosError } from "axios";

const hostname = window && window.location && window.location.hostname;

let apiPath = "/";
let withCredentials = true;
if (hostname === "localhost") {
  apiPath = "http://localhost:8502";
} else {
  apiPath = "https://passi.suek.fi";
}
apiPath += "/rest";

const instance = axios.create({
  baseURL: apiPath,
  withCredentials: withCredentials,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
});

export const getErrorMessage = (error: AxiosError) => {
  let errorMessage = error.message;
  if (error.response && error.response.data) {
    errorMessage = (error.response.data as any).Message || errorMessage;
  }
  console.log(errorMessage);
  return errorMessage;
};

export default instance;
